import React from "react";
import { Helmet } from 'react-helmet';
import { useIntl } from "react-intl";

interface IProps {
    title?: string,
    titleId?: string,
    description?: string,
    descriptionId?: string,
    canonical?: string,
    image?: string,
    type?: string,
    structuredData?: object | object[],
}

const LocalHelmet: React.FC<IProps> = ({
    title,
    titleId,
    description,
    descriptionId,
    canonical,
    image,
    type = "website",
    structuredData,
}) => {

    const intl = useIntl();
    const pageTitle = title ? title : intl.formatMessage({ id: titleId || "title" });
    const pageDescription = description ? description : intl.formatMessage({ id: descriptionId || "description" });
    const pageUrl = canonical || window.location.href;
    const schemaItems = Array.isArray(structuredData) ? structuredData : structuredData ? [structuredData] : [];
  
    return (
        <Helmet>
          <title>{pageTitle}</title>
          <meta name="description" content={pageDescription} />
          <link rel="canonical" href={pageUrl} />
          <meta property="og:title" content={pageTitle} />
          <meta property="og:description" content={pageDescription} />
          <meta property="og:url" content={pageUrl} />
          <meta property="og:type" content={type} />
          {image ? <meta property="og:image" content={image} /> : null}
          {schemaItems.map((schema, index) => (
            <script type="application/ld+json" key={index}>
              {JSON.stringify(schema)}
            </script>
          ))}
        </Helmet>
    );
};

export default (LocalHelmet);
